import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";

const enum fields {
    dataId = "dataId",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.dataId]: string;
    };
}

const InstagramFeed: React.FC<OwnProps> = ({ fields }) => {
    const feedRef = React.useRef(null);

    const loadScript = function (src: string) {
        const tag = document.createElement("script");
        tag.async = true;
        tag.src = src;
        document.getElementsByTagName("body")[0].appendChild(tag);
    };

    React.useEffect(() => {
        let HM: any;
        loadScript("https://cdn.hypemarks.com/pages/a5b5e5.js");
        window.setTimeout(() => {
            if (feedRef.current && (feedRef.current as any)?.children.length === 0) {
                HM.init();
                HM.render();
                HM.bind();
            }
        }, 600);
    });

    return (
        <div
            ref={feedRef}
            className="tintup"
            data-id={fields.dataId}
            data-columns=""
            data-expand="true"
            data-infinitescroll="true"
            data-personalization-id="1080734"
            style={{ height: "350px", width: "100%" }}
        ></div>
    );
};

const widgetModule: WidgetModule = {
    component: InstagramFeed,
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.dataId,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
